import { render, staticRenderFns } from "./StudioAboutTab.vue?vue&type=template&id=62eccb64&scoped=true"
import script from "./StudioAboutTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioAboutTab.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioAboutTab.vue?vue&type=style&index=0&id=62eccb64&prod&lang=scss&scoped=true"
import style1 from "./StudioAboutTab.vue?vue&type=style&index=1&id=62eccb64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62eccb64",
  null
  
)

export default component.exports